var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfReviewDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18022 2.345C9.21593 2.15384 9.31737 1.98118 9.46697 1.85693C9.61658 1.73269 9.80492 1.66467 9.99939 1.66467C10.1939 1.66467 10.3822 1.73269 10.5318 1.85693C10.6814 1.98118 10.7829 2.15384 10.8186 2.345L11.6944 6.97667C11.7566 7.30596 11.9166 7.60885 12.1536 7.84581C12.3905 8.08277 12.6934 8.2428 13.0227 8.305L17.6544 9.18084C17.8456 9.21654 18.0182 9.31798 18.1425 9.46758C18.2667 9.61719 18.3347 9.80553 18.3347 10C18.3347 10.1945 18.2667 10.3828 18.1425 10.5324C18.0182 10.682 17.8456 10.7835 17.6544 10.8192L13.0227 11.695C12.6934 11.7572 12.3905 11.9172 12.1536 12.1542C11.9166 12.3912 11.7566 12.694 11.6944 13.0233L10.8186 17.655C10.7829 17.8462 10.6814 18.0188 10.5318 18.1431C10.3822 18.2673 10.1939 18.3353 9.99939 18.3353C9.80492 18.3353 9.61658 18.2673 9.46697 18.1431C9.31737 18.0188 9.21593 17.8462 9.18022 17.655L8.30439 13.0233C8.24219 12.694 8.08216 12.3912 7.8452 12.1542C7.60824 11.9172 7.30535 11.7572 6.97606 11.695L2.34439 10.8192C2.15323 10.7835 1.98057 10.682 1.85632 10.5324C1.73208 10.3828 1.66406 10.1945 1.66406 10C1.66406 9.80553 1.73208 9.61719 1.85632 9.46758C1.98057 9.31798 2.15323 9.21654 2.34439 9.18084L6.97606 8.305C7.30535 8.2428 7.60824 8.08277 7.8452 7.84581C8.08216 7.60885 8.24219 7.30596 8.30439 6.97667L9.18022 2.345Z",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 1.66666V4.99999",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33334H15",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 18.3333C4.25511 18.3333 5.0013 17.5871 5.0013 16.6667C5.0013 15.7462 4.25511 15 3.33464 15C2.41416 15 1.66797 15.7462 1.66797 16.6667C1.66797 17.5871 2.41416 18.3333 3.33464 18.3333Z",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfReviewDoc);
export default __webpack_public_path__ + "static/media/pdf-review-doc.1b74f3bb0a5ff69326ea47b238b6afa4.svg";
export { ForwardRef as ReactComponent };